import { handleSessionExpired } from "./auth-session";
import { genRandomID } from "./util";

export const hdrContentType = "Content-Type";
export const mimeApplicationJson = "application/json";

// this is how we identify this particular web session
export const sessionId = genRandomID();

async function appFetchInner(uri: string, init: any): Promise<Response> {
  if (!init.headers) {
    init.headers = {};
  }
  init.headers["X-Sumatra-Online-Session-Id"] = sessionId;
  let rsp = await fetch(uri, init);
  if (rsp.status === 401) {
    handleSessionExpired();
  }
  return rsp;
}

export async function appFetch(uri: string, init: any = {}): Promise<Response> {
  return await appFetchInner(uri, init);
}

export async function appFetchPOST(uri: string, body: any, init: any = {}): Promise<Response> {
  init["method"] = "POST";
  init["body"] = body;
  return await appFetchInner(uri, init);
}

export async function appFetchPOSTJson(uri: string, body: object, init: any = {}): Promise<Response> {
  if (!init.headers) {
    init.headers = {};
  }
  init.headers[hdrContentType] = mimeApplicationJson;
  init["method"] = "POST";
  init["body"] = JSON.stringify(body);
  return await appFetchInner(uri, init);
}
